import React, { useState, useEffect } from 'react';
import apiClient from '../../api/client';

const CATEGORIAS = ['todos', 'Latinos', 'Nacionales', 'Exportacion', 'Otros', 'Cemex', 'Alterna'];

const RutasContent = ({ rutaSeleccionada, onRutaSeleccionada }) => {
    const [loading, setLoading] = useState(true);
    const [rutas, setRutas] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [filtros, setFiltros] = useState({ texto: '', categoria: 'todos' });

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const [registrosPorPagina, setRegistrosPorPagina] = useState(20);

    useEffect(() => {
        apiClient.get('/api/sesgos/rutas')
            .then(res => {
                setRutas(res.data);
                setFiltered(res.data);
            })
            .catch(err => console.error('Error al obtener rutas:', err))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        const { texto, categoria } = filtros;
        const result = rutas.filter(r => {
            const matchTexto = !texto ||
                r.PoblacionOrigen?.toLowerCase().includes(texto.toLowerCase()) ||
                r.PoblacionDestino?.toLowerCase().includes(texto.toLowerCase()) ||
                r.RazonOrigen?.toLowerCase().includes(texto.toLowerCase()) ||
                r.RazonDestino?.toLowerCase().includes(texto.toLowerCase()) ||
                String(r.id_Tipo_ruta).includes(texto);
            const matchCat = categoria === 'todos' || r.Categoria === categoria;
            return matchTexto && matchCat;
        });
        setFiltered(result);
        setPaginaActual(1);
    }, [filtros, rutas]);

    const totalPaginas = Math.ceil(filtered.length / registrosPorPagina);
    const inicio = (paginaActual - 1) * registrosPorPagina;
    const datosPaginados = filtered.slice(inicio, inicio + registrosPorPagina);

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status" />
            </div>
        );
    }

    return (
        <div className="card shadow mb-3">
            <div className="card-header py-2 d-flex align-items-center justify-content-between flex-wrap" style={{ gap: '8px' }}>
                <h6 className="m-0 font-weight-bold text-primary">
                    <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
                    Rutas con sesgos
                    <span className="badge badge-warning ml-2">{filtered.length}</span>
                </h6>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                    <select
                        className="form-control form-control-sm"
                        style={{ width: 'auto' }}
                        value={filtros.categoria}
                        onChange={e => setFiltros(f => ({ ...f, categoria: e.target.value }))}
                    >
                        {CATEGORIAS.map(c => (
                            <option key={c} value={c}>{c === 'todos' ? 'Todas las categorías' : c}</option>
                        ))}
                    </select>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Buscar origen, destino, ruta..."
                        style={{ width: '180px' }}
                        value={filtros.texto}
                        onChange={e => setFiltros(f => ({ ...f, texto: e.target.value }))}
                    />
                    <select
                        className="form-control form-control-sm"
                        style={{ width: 'auto' }}
                        value={registrosPorPagina}
                        onChange={e => { setRegistrosPorPagina(Number(e.target.value)); setPaginaActual(1); }}
                    >
                        {[10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                </div>
            </div>

            <div className="card-body p-0">
                <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <table className="table table-sm table-hover mb-0" style={{ fontSize: '0.8rem' }}>
                        <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Ruta</th>
                                <th>Origen</th>
                                <th>Destino</th>
                                <th>Categoría</th>
                                <th className="text-center">Pendientes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {datosPaginados.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-muted">
                                        <i className="fas fa-check-circle text-success mr-2"></i>
                                        Sin sesgos con los filtros actuales.
                                    </td>
                                </tr>
                            ) : datosPaginados.map(ruta => {
                                const isSelected = rutaSeleccionada?.id_Tipo_ruta === ruta.id_Tipo_ruta;
                                return (
                                    <tr
                                        key={ruta.ID_ruta}
                                        onClick={() => onRutaSeleccionada(isSelected ? null : ruta)}
                                        style={{ cursor: 'pointer' }}
                                        className={isSelected ? 'table-info' : ''}
                                    >
                                        <td className="font-weight-bold text-primary">{ruta.id_Tipo_ruta}</td>
                                        <td className="small">
                                            <div>{ruta.RazonOrigen || ruta.PoblacionOrigen}</div>
                                            <div className="text-muted" style={{ fontSize: '0.72rem' }}>{ruta.PoblacionOrigen}</div>
                                        </td>
                                        <td className="small">
                                            <div>{ruta.RazonDestino || ruta.PoblacionDestino}</div>
                                            <div className="text-muted" style={{ fontSize: '0.72rem' }}>{ruta.PoblacionDestino}</div>
                                        </td>
                                        <td>
                                            {ruta.Categoria
                                                ? <span className="badge badge-secondary">{ruta.Categoria}</span>
                                                : <span className="text-muted small">—</span>
                                            }
                                            {ruta.Alterna && <span className="badge badge-light ml-1">Alterna</span>}
                                        </td>
                                        <td className="text-center">
                                            <span className={`badge ${ruta.count_cruces >= 10 ? 'badge-danger' : ruta.count_cruces >= 3 ? 'badge-warning' : 'badge-info'}`}>
                                                {ruta.count_cruces}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {totalPaginas > 1 && (
                <div className="card-footer py-2 d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                        {inicio + 1}–{Math.min(inicio + registrosPorPagina, filtered.length)} de {filtered.length}
                    </small>
                    <nav>
                        <ul className="pagination pagination-sm mb-0">
                            <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setPaginaActual(p => p - 1)}>‹</button>
                            </li>
                            {Array.from({ length: totalPaginas }, (_, i) => i + 1)
                                .filter(p => p === 1 || p === totalPaginas || Math.abs(p - paginaActual) <= 1)
                                .reduce((acc, p, idx, arr) => {
                                    if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
                                    acc.push(p);
                                    return acc;
                                }, [])
                                .map((p, i) => p === '...' ? (
                                    <li key={`e${i}`} className="page-item disabled"><span className="page-link">…</span></li>
                                ) : (
                                    <li key={p} className={`page-item ${paginaActual === p ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => setPaginaActual(p)}>{p}</button>
                                    </li>
                                ))
                            }
                            <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setPaginaActual(p => p + 1)}>›</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            )}
        </div>
    );
};

export default RutasContent;
